
import axios, { Axios, AxiosRequestConfig } from 'axios'

import { owlAddAjaxError, owlAddAjaxInfo } from '../utils/owl'
import { getI18nParams } from '../utils/i18n'
import { failToast } from '../utils/toast'


function onRequestError (param: {errorMessage: string, code: number, url: string, noToast?: boolean, requestParams?: any,}) {
  owlAddAjaxError(
    {
      name: `Code: ${param.code}`,
      msg: `API: ${(param.url || '').replace(/\?.*$/, '')},  MSG: ${param.errorMessage}`,
      message: `API: ${(param.url || '').replace(/\?.*$/, '')},  MSG: ${param.errorMessage}`,
    },
    {
      // @ts-ignore
      fullPath: param.url || '',
      config: JSON.stringify(param.requestParams || {}),
    },
  )
  if (!param.noToast) {
    failToast(param.errorMessage)
  }
}


const interceptors = {
// M端国际化请求头
  addMI18nHeader (config:any) {
    const i18nParams = getI18nParams()
    return { ...config, headers: { ...config.headers, ...i18nParams } }
  },

  // 响应拦截器：接口错误吗处理拦截器，0成功，其他为失败，可选接入
  codeCheckWithError (response: any) {
    const { data } = response
    const { msg, message, data: realData } = data || {}

    const errorCode = data?.status ?? data?.code
    const errorMessage = msg || message || realData?.msg || realData?.message
    if (errorCode) {
      onRequestError({ errorMessage, code: errorCode, url: response.config?.url, requestParams: {
        headers: response.config?.headers,
        data: response.config?.data,
        params: response.config?.params,
        traceid: response.request?.traceid,
      } })
      throw new Error(errorMessage)
    }
    return realData
  },
  // http错误
  onResponseError (error: any) {
    onRequestError({ errorMessage: error.message, code: error.status, url: error.config.url })
    return Promise.reject(error)
  },
}

const request = axios.create()
request.interceptors.request.use(interceptors.addMI18nHeader)
request.interceptors.response.use(interceptors.codeCheckWithError, interceptors.onResponseError)


// 定义函数类型
interface  RequestWithResponseType extends Omit<Axios, 'post' | 'get'> {
  post<T>(url: string, data?: {[k:string]: any}, config?: AxiosRequestConfig): Promise<T>;
  get<T>(url: string, config?: AxiosRequestConfig): Promise<T>;
}

export default request as RequestWithResponseType

